import { render, staticRenderFns } from "./NavMenuGroupGiftCards.vue?vue&type=template&id=3a6056ce&scoped=true"
import script from "./NavMenuGroupGiftCards.vue?vue&type=script&lang=js"
export * from "./NavMenuGroupGiftCards.vue?vue&type=script&lang=js"
import style0 from "./NavMenuGroupGiftCards.vue?vue&type=style&index=0&id=3a6056ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6056ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDivider,VIcon,VImg,VList,VListItem,VTextField})
